var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"go-top"},[_c('img',{attrs:{"src":require("../assets/images/use/use-top.png"),"alt":"返回顶部"},on:{"click":_vm.backTop}})])
}
var staticRenderFns = []

export { render, staticRenderFns }